<template>
    <div class="shipDetail-container">
        <div class="shipDetail-shipBanner">
            <div class="shipBanner-img" v-show="!isShowVideo">
                <div class="shipBanner-pic">
                    <img :src="ship.mobileVideoCover" :alt="ship.shipCNName">
                </div>
                <div class="shipBanner-playBtn" v-if="ship.videoUrl&&ship.videoUrl.length>0" @click="playVideo()">
                    <img src="https://resource.rcclchina.com.cn/shipDetail/shipDetail.png" :alt="ship.shipCNName">
                </div>

                <div class="shipBanner-slideVRBtn" v-if="ship.hasVr">
                    <div class="shipBanner-slideVRBtn-txt linearGradient"></div>
                    <div @drag="onGlassDrag" @dragleave="onGalssDragEnd" id="shipBanner-slideVRBtn-glasses" class="shipBanner-slideVRBtn-glasses" :style="glassStyle">
                        <img src="https://resource.rcclchina.com.cn/shipDetail/bannerVRGlasses.png">
                    </div>
                </div>


                <div class="shipBanner-bannerTitle">
                    <p class="shipBanner-shipCName">{{ship.title}}</p>
                    <p class="shipBanner-shipEName">{{ship.shipENName}}<sup></sup></p>
                    <p class="shipBanner-shipDeparture"></p>
                </div>
            </div>
            <div class="shipBanner-video" v-show="isShowVideo" v-if="ship.videoUrl&&ship.videoUrl.length>0">
                <div class="video">
                    <video ref="videoShip" class="video-mp4"
                        :src="ship.videoUrl" controls="" preload="auto"
                        webkit-playsinline="" playsinline=""></video>
                </div>
            </div>
        </div>

        <div class="shipDetail-shipIntro">
            <div class="shipDetail-shipIntroOverFlow">
                <div class="shipDetail-shipIntroL" v-if="ship.shipCode=='QN'">
                    <img src="https://resource.rcclchina.com.cn/shipDetail/shipIntroPic.png" :alt="ship.shipCNName">
                </div>
                <div class="shipDetail-shipIntroL" v-else-if="ship.shipCode=='OV'">
                    <img src="https://resource.rcclchina.com.cn/OV%E8%88%B9%E9%98%9F/OVpanda%20(1).png" :alt="ship.shipCNName" />
                </div>
                <div class="shipDetail-shipIntroR" :class="{'shipDetail-shipIntroRBig': ship.shipCode !='QN' && ship.shipCode!='OV'}">
                    <p class="shipDetail-shipIntroR-mainHeadLines">{{ship.contentTitle}}</p>
                    <p class="shipDetail-shipIntroR-subTitle">{{ship.contentSubTitle}}</p>
                    <div class="shipIndex-ship-itemInfo">
                        <div>
                            <div class="shipIndex-ship-itemInfoIcon">
                                <img class="shipIndex-ship-itemNum"
                                    src="https://resource.rcclchina.com.cn/mobileShip/royalShipIcon.png">
                            </div>
                            <div class="shipIndex-ship-itemInfoTxt">

                                <p>{{ship.capacity}}</p>
                                <p class="shipIndex-ship-itemUnit">载客人数</p>
                            </div>
                        </div>
                        <div>
                            <div class="shipIndex-ship-itemInfoIcon">
                                <img class="shipIndex-ship-itemWeight"
                                    src="https://resource.rcclchina.com.cn/mobileShip/royalShipIconW.png">
                            </div>
                            <div class="shipIndex-ship-itemInfoTxt">

                                <p>{{ship.weight}}</p>
                                <p class="shipIndex-ship-itemUnit">吨位</p>
                            </div>
                        </div>
                    </div>
                    <p class="shipDetail-shipIntroR-txt">
                        {{ship.content}}
                    </p>
                </div>
            </div>
            <div class="shipDetail-shipIntroCon">
                <div class="shipDetail-shipIntroCon-item">
                    <div class="shipDetail-shipIntroCon-itemPicS">
                        <img src="https://resource.rcclchina.com.cn/shipDetail/speedIcon.png">
                    </div>
                    <div class="shipDetail-shipIntroCon-itemInfo">
                        <p>{{ship.speed}} 节</p>
                        <p>航速</p>
                    </div>
                </div>
                <div class="shipDetail-shipIntroCon-item">
                    <div class="shipDetail-shipIntroCon-itemPicL">
                        <img src="https://resource.rcclchina.com.cn/shipDetail/lengthIcon.png">
                    </div>
                    <div class="shipDetail-shipIntroCon-itemInfo">
                        <p>{{ship.shipLength}} 米</p>
                        <p>总长度</p>
                    </div>
                </div>
                <div class="shipDetail-shipIntroCon-item">
                    <div class="shipDetail-shipIntroCon-itemPicW">
                        <img src="https://resource.rcclchina.com.cn/shipDetail/widthIcon.png">
                    </div>
                    <div class="shipDetail-shipIntroCon-itemInfo">
                        <p>{{ship.shipWidth}} 米</p>
                        <p>宽度</p>
                    </div>
                </div>
                <div class="shipDetail-shipIntroCon-item">
                    <div class="shipDetail-shipIntroCon-itemPicCreate">
                        <img src="https://resource.rcclchina.com.cn/shipDetail/icon1.png">
                    </div>
                    <div class="shipDetail-shipIntroCon-itemInfo">
                        <p>{{ship.shipExplain}}</p>
                        <p>船厂建造</p>
                    </div>
                </div>
                <div class="shipDetail-shipIntroCon-item">
                    <div class="shipDetail-shipIntroCon-itemPicTime">
                        <img src="https://resource.rcclchina.com.cn/shipDetail/tonnageIcon.png">
                    </div>
                    <div class="shipDetail-shipIntroCon-itemInfo">
                        <p>{{ship.firstTime}}</p>
                        <p>{{ship.departPort}}</p>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
// import touch from 'touchjs'
export default {
    name: "ShipDetailBanner",
    props: {
        ship: {
            type: Object,
            default () {
                return {}
            }
        }
    },
    data () {
        return {
            isShowVideo: false,
            glassDistance: 0
        }
    },
    mounted () {
        
    },
    beforeDestroy () {

    },
    methods: {
        playVideo () {
            this.isShowVideo = true
            this.$refs.videoShip.play()
        },
        onGlassDrag(ev) {
            
            const btnWidth = 350
            const glassWidth = 50
            const max_X = btnWidth - glassWidth - 6
            const self = this
            var distanceX = ev.detail.distanceX;
            if (distanceX < 0) {
                distanceX = 0;
            } else if (distanceX > max_X) {
                distanceX = max_X;
            }
            self.glassDistance = distanceX
            
            if (distanceX > max_X/3) {
                location.href = self.ship.vrUrl
            }
        },
        onGalssDragEnd (ev) {
            const btnWidth = 350
            const glassWidth = 50
            const max_X = btnWidth - glassWidth - 6
            const self = this
            var distanceX = ev.detail.distanceX;
            if (distanceX < max_X/3) {
                self.glassDistance = 0
            } else {
                location.href = self.ship.vrUrl
            }
        },
        // glassDragHandler () {
        //     //打开VR的滑动
            
        //     touch.on('#shipBanner-slideVRBtn-glasses', 'drag', function (ev) {
                
        //     })

        //     touch.on('#shipBanner-slideVRBtn-glasses', 'dragend', function (ev) {
                
        //     })
        // }
    },
    computed: {
        glassStyle () {
            return {
                'transform': 'translateX('+this.glassDistance+'px)'
            }
        }
    },
    watch: {
        ship (newValue) {
            if (newValue && newValue.hasVr) {
                setTimeout(()=> {
                    // this.glassDragHandler()
                }, 1000)
            }
        }
    }
}
</script>

<style lang="less" scoped>
img {
    width: 100%;
}
.shipDetail-container {
    background-color: #f2f2f2;
    .shipDetail-shipTitle {
        padding-top: 20px;
        padding-bottom: 17px;
        position: relative;
        height: 13px;
        line-height: 13px;
        background-color: #fff;
        .shipDetail-shipTitle-line {
            height: 1px;
            background-color: #fecc46;
            margin-left: 3.2%;
            margin-right: 3.2%;
        }
        .shipDetail-shipTitle-txt {
            width: 66px;
            position: absolute;
            top: 13px;
            left: 50%;
            margin-left: -33px;
            padding: 0 1.4667%;
            background-color: #fff;
            text-align: center;
            color: #061556;
            font-size: 13px;
            font-weight: bold;
        }
    }
    .shipDetail-shipBanner {
        width: 100%;
        position: relative;
        background-color: #fff;
        .shipBanner-pic {
            width: 100%;
        }
        .shipBanner-playBtn {
            width: 24.4%;
            position: absolute;
            top: 35.614%;
            left: 50%;
            margin-left: -12.2%;
        }
        .shipBanner-slideVRBtn {
            position: absolute;
            bottom: 4.881%;
            left: 50%;
            width: 93.334%;
            height: 35px;
            margin-left: -46.667%;
            background: rgba(254, 189, 17, 0.85);
            border-radius: 8px;
            .shipBanner-slideVRBtn-txt {
                width: 170px;
                height: 22px;
                margin: 6px auto 0;
                opacity: 0.5;
                -webkit-mask-image: url('../../assets/bannerVRTxt.png');
                -webkit-mask-position: center;
                -webkit-mask-repeat: no-repeat;
                -webkit-mask-size: 100%;
                background: linear-gradient(135deg, #646464 50%, #fff 60%, #646464 70%);
                background-size: 200% 200%;
                -webkit-transform: translate3d(0, 0, 0);
                transform: translate3d(0, 0, 0);
                -webkit-animation-fill-mode: both;
                animation-fill-mode: both;
                -webkit-animation-duration: 5s;
                animation-duration: 5s;
                -webkit-animation-name: linearGradient;
                animation-name: linearGradient;
                -webkit-animation-timing-function: linear;
                animation-timing-function: linear;
                -webkit-animation-iteration-count: infinite;
                animation-iteration-count: infinite;
            }
            .shipBanner-slideVRBtn-glasses {
                position: absolute;
                left: 3px;
                top: 3px;
                width: 50px;
            }
        }
        .shipBanner-bannerTitle {
            width: 100%;
            position: absolute;
            top: 6.356%;
            left: 0;
            color: #fff;
            text-align: center;
            p {
                margin: 0;
            }
            .shipBanner-shipCName {
                font-size: 17.5px;
            }
            .shipBanner-shipEName {
                font-size: 16px;
                font-style: italic;
                sup {
                    font-size: 5px;
                    top: -0.5em;
                }
            }
        }
        .video-mp4 {
            width: 100%;
            height: 211px;
        }
    }

    .shipDetail-shipIntro {
        background-color: #fff;
        padding-top: 25px;
        .shipDetail-shipIntroOverFlow {
            overflow: hidden;
            .shipDetail-shipIntroL {
                float: left;
                width: 20.134%;
                padding-top: 4.110%;
            }
            
            .shipDetail-shipIntroR {
                float: right;
                width: 77.999%;
                margin-left: 1.867%;
                padding-right: 4.534%;
                p {
                    margin: 0;
                }
                .shipDetail-shipIntroR-mainHeadLines {
                    color: #0073af;
                    font-size: 20px;
                    margin-bottom: 3.94% !important;
                }
                .shipDetail-shipIntroR-subTitle {
                    color: #333;
                    font-size: 12px;
                    margin-bottom: 17px !important;
                }
                .shipIndex-ship-itemInfo {
                    margin-bottom: 18px;
                    > div {
                        display: inline-block;
                        margin-right: 19px;
                        p {
                            margin: 0;
                            font-size: 13px;
                            color: #333;
                            margin-left: 5px;
                        }
                    }
                    .shipIndex-ship-itemInfoIcon {
                        width: 30px;
                        height: 30px;
                        text-align: center;
                        background-color: rgba(255,255,255,.3);
                        border-radius: 2px;
                        display: inline-block;
                        vertical-align: bottom;
                        .shipIndex-ship-itemNum {
                            width: 29px;
                            height: 30px;
                            vertical-align: middle;
                        }
                    }
                    .shipIndex-ship-itemInfoTxt {
                        display: inline-block;
                        vertical-align: bottom;
                        margin-left: 5px;
                        p {
                            margin: 0;
                        }
                        .shipIndex-ship-itemUnit {
                            transform: scale(.83);
                            -webkit-transform: scale(.83);
                            -moz-transform: scale(.83);
                            -o-transform: scale(.83);
                            margin: -4px 0 0 -5px !important;
                        }
                    }
                }
                .shipDetail-shipIntroR-txt {
                    color: #808080;
                    font-size: 10px;
                    margin: 0px;
                }
            }
            div.shipDetail-shipIntroRBig {
                width: 94%;
                text-align: center;
            }
        }

        .shipDetail-shipIntroCon {
            clear: both;
            padding: 3.354% 0px 3.354% 22px;
            background-color: #061556;
            margin-top: 21px;
            text-align: center;
            img {
                width: 100%;
                display: block;
            }
            .shipDetail-shipIntroCon-item {
                display: inline-block;
                margin-right: 4.267%;
                margin-left: -4px;
                text-align: center;
                .shipDetail-shipIntroCon-itemPicL {
                    width: 15px;
                    height: 17px;
                    margin: 3px auto 0 auto;
                }
                .shipDetail-shipIntroCon-itemPicS {
                    width: 23px;
                    height: 23px;
                    margin: 0 auto;
                }
                .shipDetail-shipIntroCon-itemPicW {
                    width: 23px;
                    height: 17px;
                    margin: 3px auto 0 auto;
                }
                .shipDetail-shipIntroCon-itemPicCreate {
                    width: 23px;
                    height: 22px;
                    margin: 0 auto;
                }
                .shipDetail-shipIntroCon-itemPicTime {
                    width: 27px;
                    height: 18px;
                    margin: 0 auto;
                }
                .shipDetail-shipIntroCon-itemInfo p {
                    margin-bottom: -8px;
                    margin-top: 4px;
                    color: #fff;
                    font-size: 12px;
                    transform: scale(.9);
                    -webkit-transform: scale(.9);
                    -moz-transform: scale(.9);
                    -o-transform: scale(.9);
                    max-width: 85px;
                }
            }
        }
    }
}

@-webkit-keyframes linearGradient {
    0% {
        background-position: 200% 50%
    }

    100% {
        background-position: -200% 50%
    }
}

@keyframes linearGradient {
    0% {
        background-position: 200% 50%
    }

    100% {
        background-position: -200% 50%
    }
}
</style>